(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[591],{

/***/ 7746:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_partners/[partnerSlug]",
      function () {
        return __webpack_require__(7321);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4890);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2980);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: calc( 42px + ( 4 * var( --stack-basis ) ) ) auto 0 auto;\n  /* max-width: 2000px; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function AppChrome(param) {
    var _navigationBar = param.navigationBar, navigationBar = _navigationBar === void 0 ? null : _navigationBar, _footerPageSegments = param.footerPageSegments, footerPageSegments = _footerPageSegments === void 0 ? null : _footerPageSegments, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                navigationBar: navigationBar
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledAppMain, {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                pageSegments: footerPageSegments
            })
        ]
    });
}
var StyledAppMain = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc7e6c0-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (AppChrome);


/***/ }),

/***/ 2980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _lib_craft__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8767);
/* harmony import */ var _pageSegments_PageSegments__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1135);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto;\n  /* max-width: 2000px; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function Footer(param) {
    var _pageSegments = param.pageSegments, pageSegments = _pageSegments === void 0 ? null : _pageSegments;
    var ref, ref1, ref2;
    var craftData = (0,_lib_craft__WEBPACK_IMPORTED_MODULE_2__/* .useCraft */ .Yi)();
    var segments = pageSegments || (craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.footer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.pageSegments);
    if (!segments) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledFooter, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pageSegments_PageSegments__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            pageSegments: segments
        })
    });
}
var StyledFooter = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e2154cb-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 4890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./lib/craft/index.tsx + 31 modules
var craft = __webpack_require__(8767);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(6797);
// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(4970);
// EXTERNAL MODULE: ./components/BrixelLogo.tsx
var BrixelLogo = __webpack_require__(2290);
// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(5741);
// EXTERNAL MODULE: ./components/navigationBar/NavigationBar.tsx + 6 modules
var NavigationBar = __webpack_require__(8549);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
;// CONCATENATED MODULE: ./components/icons/TelephoneIcon.tsx

function TelephoneIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "19",
        height: "18",
        viewBox: "0 0 19 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.34452 7.54331C6.47782 7.41006 6.58356 7.25186 6.65571 7.07775C6.72785 6.90363 6.76498 6.717 6.76498 6.52853C6.76498 6.34006 6.72785 6.15343 6.65571 5.97931C6.58356 5.80519 6.47782 5.64699 6.34452 5.51375L4.82218 3.99212C4.55311 3.72313 4.18822 3.57202 3.80776 3.57202C3.42729 3.57202 3.06241 3.72313 2.79334 3.99212L1.95827 4.82719C1.60831 5.17815 1.39021 5.63915 1.3408 6.13231C1.29139 6.62547 1.41371 7.12057 1.68709 7.53398C4.1442 11.2325 7.31495 14.4032 11.0134 16.8603C11.4269 17.1336 11.9221 17.2558 12.4152 17.2063C12.9084 17.1567 13.3694 16.9385 13.7202 16.5884L14.556 15.7534C14.825 15.4843 14.9761 15.1194 14.9761 14.7389C14.9761 14.3585 14.825 13.9936 14.556 13.7245L13.0337 12.2029C12.7646 11.9339 12.3997 11.7828 12.0193 11.7828C11.6388 11.7828 11.2739 11.9339 11.0048 12.2029L10.4976 12.7101C8.79588 11.3104 7.23415 9.74868 5.83444 8.04693L6.34452 7.54331Z",
                stroke: "#009877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5791 0.718506C11.7672 0.718506 13.8657 1.58772 15.4129 3.13494C16.9601 4.68216 17.8293 6.78064 17.8293 8.96874",
                stroke: "#009877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5791 3.58813C11.0061 3.58813 12.3747 4.15502 13.3838 5.16407C14.3928 6.17313 14.9597 7.5417 14.9597 8.96872",
                stroke: "#009877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5791 6.45776C10.245 6.45776 10.8837 6.72231 11.3546 7.1932C11.8255 7.66409 12.09 8.30276 12.09 8.96871",
                stroke: "#009877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/OpenClosed.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 4px;\n  color: ",
        ";\n  font-size: ",
        ";\n\n  > span {\n    @media ( max-width: 600px ) {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  font-size: inherit;\n  color: inherit;\n  text-decoration-color: transparent;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 2px;\n  transition: text-decoration-color .3s ease-out;\n  &:hover {\n    text-decoration-color: inherit;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 20rem;\n  background-color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







function OpenClosed() {
    var ref, ref1;
    var ref2 = (0,router.useRouter)(), locale = ref2.locale, defaultLocale = ref2.defaultLocale;
    var craftData = (0,craft/* useCraft */.Yi)();
    var ref3 = (0,react.useState)(null), isOpen = ref3[0], setIsOpen = ref3[1];
    var ref4 = (0,react.useState)(null), nextOpen = ref4[0], setNextOpen = ref4[1];
    var serializedOpeningTimes = JSON.stringify(craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.businessHours) === null || ref1 === void 0 ? void 0 : ref1.openingTimes);
    var openingTimes = (0,react.useMemo)(function() {
        var ref, ref1;
        return (craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.businessHours) === null || ref1 === void 0 ? void 0 : ref1.openingTimes) || [];
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        serializedOpeningTimes
    ]);
    var weekdayFormatter = new Intl.DateTimeFormat([
        locale || defaultLocale || "en_US"
    ], {
        weekday: "long"
    });
    var timeFormatter = new Intl.DateTimeFormat([
        locale || defaultLocale || "en_US"
    ], {
        timeStyle: "short"
    });
    (0,react.useEffect)(function() {
        var timer = null;
        if (timer) {
            clearInterval(timer);
        }
        timer = setInterval(function() {
            // check if open
            setIsOpen(areWeOpen(openingTimes));
            setNextOpen(whenAreWeNextOpen(openingTimes));
        }, 1000 * 60);
        setIsOpen(areWeOpen(openingTimes));
        setNextOpen(whenAreWeNextOpen(openingTimes));
    }, [
        openingTimes
    ]);
    if (isOpen === null) {
        return null;
    }
    if (isOpen) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOpenClosed, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        description: "[Brixel] is open",
                        defaultMessage: "is open",
                        id: "FthgtD"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CallUs, {})
            ]
        });
    }
    if (nextOpen && nextOpen.getDate() !== new Date().getDate()) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOpenClosed, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    description: "opens on [Monday/Tuesday/etc…]",
                    defaultMessage: "opens on ",
                    id: "RlDzFA"
                }),
                " ",
                weekdayFormatter.format(nextOpen)
            ]
        });
    }
    if (nextOpen) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOpenClosed, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    description: "opens at [9am]",
                    defaultMessage: "opens at ",
                    id: "HS4fmx"
                }),
                " ",
                timeFormatter.format(nextOpen)
            ]
        });
    }
    return null;
}
function CallUs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCallUs, {
        href: "tel:+41 44 552 57 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPhoneIcon, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TelephoneIcon, {})
            }),
            "+41 44 552 57 30"
        ]
    });
}
var StyledOpenClosed = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef933484-0"
})(_templateObject(), function(p) {
    return p.theme.colors.green400;
}, function(p) {
    return p.theme.typo.sizes.dropped;
});
var StyledCallUs = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-ef933484-1"
})(_templateObject1());
var StyledPhoneIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef933484-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.green100;
});
function areWeOpen(openingTimes) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var today = now.getDay();
    var todaysOpeningTimes = openingTimes.filter(function(ot) {
        return ot.day === daysOfTheWeek[today];
    });
    var timeSlots = todaysOpeningTimesToSlots(now, todaysOpeningTimes);
    for(var i = 0, len = timeSlots.length; i < len; i += 1){
        var slot = timeSlots[i];
        if (now >= slot.opens && now <= slot.closes) {
            return true;
        }
    }
    return false;
}
function whenAreWeNextOpen(openingTimes) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var nextOpenToday = whenAreWeNextOpenOnDay(now, openingTimes);
    if (nextOpenToday) {
        return nextOpenToday;
    }
    for(var i = 0, len = daysOfTheWeek.length; i < len; i += 1){
        var thisDay = new Date(now);
        thisDay.setUTCHours(0);
        thisDay.setUTCMinutes(0);
        thisDay.setUTCSeconds(0);
        thisDay.setDate(thisDay.getDate() + i);
        var nextOpenThisDay = whenAreWeNextOpenOnDay(thisDay, openingTimes);
        if (nextOpenThisDay) {
            return nextOpenThisDay;
        }
    }
    return false;
}
function whenAreWeNextOpenOnDay(day, openingTimes) {
    var today = day.getDay();
    var todaysOpeningTimes = openingTimes.filter(function(ot) {
        return ot.day === daysOfTheWeek[today];
    });
    var timeSlots = todaysOpeningTimesToSlots(day, todaysOpeningTimes);
    for(var i = 0, len = timeSlots.length; i < len; i += 1){
        var slot = timeSlots[i];
        if (day < slot.opens) {
            return slot.opens;
        }
    }
    return false;
}
function todaysOpeningTimesToSlots(now, openingTimes) {
    return openingTimes.reduce(function(slots, ot, currentIndex) {
        var ref;
        if (currentIndex % 2) {
            return slots;
        }
        var openingTime = new Date(ot.time);
        var closingTime = new Date(((ref = openingTimes[currentIndex + 1]) === null || ref === void 0 ? void 0 : ref.time) || null);
        openingTime.setFullYear(now.getFullYear());
        openingTime.setMonth(now.getMonth());
        openingTime.setDate(now.getDate());
        closingTime.setFullYear(now.getFullYear());
        closingTime.setMonth(now.getMonth());
        closingTime.setDate(now.getDate());
        return (0,_to_consumable_array/* default */.Z)(slots).concat([
            {
                opens: openingTime,
                closes: closingTime
            }, 
        ]);
    }, []);
}
var daysOfTheWeek = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday", 
];

;// CONCATENATED MODULE: ./components/Header.tsx

function Header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: ",
        ";\n"
    ]);
    Header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  > * {\n    margin-right: 1rem;\n  }\n\n  > * + *:last-child {\n    margin-left: auto;\n    margin-right: 0;\n  }\n\n  svg {\n    display: block;\n  }\n"
    ]);
    Header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









function Header(param) {
    var _logoLink = param.logoLink, logoLink = _logoLink === void 0 ? "/" : _logoLink, _navigationBar = param.navigationBar, navigationBar = _navigationBar === void 0 ? null : _navigationBar, _openClosed = param.openClosed, openClosed = _openClosed === void 0 ? null : _openClosed, _children = param.children, children = _children === void 0 ? null : _children;
    var ref, ref1, ref2, ref3, ref4;
    var craftData = (0,craft/* useCraft */.Yi)();
    var navBar = navigationBar || (craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.header) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.navigationBar);
    var showOpenClosed = openClosed === null ? craftData === null || craftData === void 0 ? void 0 : (ref3 = craftData.pageProps) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.businessHours) === null || ref4 === void 0 ? void 0 : ref4.openSign : openClosed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            $containerType: "small-margin",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.ZP, {
                $top: 2,
                $bottom: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderInner, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: logoLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrixelLogo/* default */.Z, {
                                breakpoint: 500
                            })
                        }),
                        showOpenClosed && /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenClosed, {}),
                        !!(navBar === null || navBar === void 0 ? void 0 : navBar.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar/* default */.Z, {
                            navigationBar: navBar
                        }),
                        children
                    ]
                })
            })
        })
    });
}
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61651a6-0"
})(Header_templateObject(), function(p) {
    return p.theme.colors.realWhite;
});
var StyledHeaderInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61651a6-1"
})(Header_templateObject1());
/* harmony default export */ var components_Header = (Header);


/***/ }),

/***/ 534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function FiveStars() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "69",
        height: "12",
        viewBox: "0 0 69 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.801 3.59629H7.89462L6.44141 0.413773C6.36773 0.274416 6.2538 0.160477 6.11444 0.0868013C6.02529 0.0402007 5.9278 0.0116905 5.82759 0.00291116C5.72738 -0.00586815 5.62643 0.00525686 5.53053 0.035646C5.43464 0.0660351 5.3457 0.115088 5.26884 0.179983C5.19197 0.244877 5.1287 0.324331 5.08266 0.413773L3.62946 3.59629H0.723046C0.617997 3.59342 0.513576 3.61338 0.416985 3.65477C0.320394 3.69617 0.233932 3.75802 0.163562 3.83607C0.0462503 3.97989 -0.0115818 4.16314 0.00192925 4.34824C0.0154403 4.53335 0.0992702 4.70626 0.236222 4.83152L2.72847 7.28744L1.34792 10.4627C1.26284 10.608 1.23084 10.7783 1.25741 10.9445C1.28397 11.1108 1.36744 11.2627 1.49356 11.3742C1.61968 11.4857 1.78062 11.55 1.94887 11.556C2.11712 11.5621 2.28225 11.5095 2.41603 11.4073L5.76567 9.52537L9.11531 11.4073C9.24967 11.5012 9.41184 11.5469 9.57548 11.537C9.73912 11.5271 9.8946 11.4622 10.0167 11.3528C10.1387 11.2433 10.2202 11.0958 10.2478 10.9342C10.2755 10.7727 10.2476 10.6065 10.1689 10.4627L8.78834 7.28744L11.2806 4.83152C11.3564 4.7613 11.4163 4.67572 11.4564 4.58049C11.4965 4.48527 11.5158 4.38259 11.5131 4.2793C11.5022 4.09673 11.4228 3.925 11.2908 3.7984C11.1588 3.67179 10.9839 3.59962 10.801 3.59629Z",
                fill: "#009877"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M24.9709 3.59629H22.0645L20.6113 0.413773C20.5377 0.274416 20.4237 0.160477 20.2844 0.0868013C20.1952 0.0402007 20.0977 0.0116905 19.9975 0.00291116C19.8973 -0.00586815 19.7963 0.00525686 19.7005 0.035646C19.6046 0.0660351 19.5156 0.115088 19.4388 0.179983C19.3619 0.244877 19.2986 0.324331 19.2526 0.413773L17.7994 3.59629H14.893C14.7879 3.59342 14.6835 3.61338 14.5869 3.65477C14.4903 3.69617 14.4039 3.75802 14.3335 3.83607C14.2162 3.97989 14.1583 4.16314 14.1719 4.34824C14.1854 4.53335 14.2692 4.70626 14.4061 4.83152L16.8984 7.28744L15.5178 10.4627C15.4328 10.608 15.4008 10.7783 15.4273 10.9445C15.4539 11.1108 15.5374 11.2627 15.6635 11.3742C15.7896 11.4857 15.9505 11.55 16.1188 11.556C16.287 11.5621 16.4522 11.5095 16.586 11.4073L19.9356 9.52537L23.2852 11.4073C23.4196 11.5012 23.5818 11.5469 23.7454 11.537C23.909 11.5271 24.0645 11.4622 24.1866 11.3528C24.3086 11.2433 24.3901 11.0958 24.4177 10.9342C24.4454 10.7727 24.4176 10.6065 24.3388 10.4627L22.9583 7.28744L25.4505 4.83152C25.5263 4.7613 25.5862 4.67572 25.6263 4.58049C25.6664 4.48527 25.6858 4.38259 25.683 4.2793C25.6721 4.09673 25.5927 3.925 25.4607 3.7984C25.3287 3.67179 25.1538 3.59962 24.9709 3.59629Z",
                fill: "#009877"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M39.1409 3.59629H36.2345L34.7813 0.413773C34.7076 0.274416 34.5936 0.160477 34.4543 0.0868013C34.3651 0.0402007 34.2676 0.0116905 34.1674 0.00291116C34.0672 -0.00586815 33.9663 0.00525686 33.8704 0.035646C33.7745 0.0660351 33.6855 0.115088 33.6087 0.179983C33.5318 0.244877 33.4685 0.324331 33.4225 0.413773L31.9693 3.59629H29.0629C28.9578 3.59342 28.8534 3.61338 28.7568 3.65477C28.6602 3.69617 28.5738 3.75802 28.5034 3.83607C28.3861 3.97989 28.3283 4.16314 28.3418 4.34824C28.3553 4.53335 28.4391 4.70626 28.5761 4.83152L31.0683 7.28744L29.6878 10.4627C29.6027 10.608 29.5707 10.7783 29.5973 10.9445C29.6238 11.1108 29.7073 11.2627 29.8334 11.3742C29.9595 11.4857 30.1205 11.55 30.2887 11.556C30.457 11.5621 30.6221 11.5095 30.7559 11.4073L34.1055 9.52537L37.4552 11.4073C37.5895 11.5012 37.7517 11.5469 37.9153 11.537C38.079 11.5271 38.2344 11.4622 38.3565 11.3528C38.4786 11.2433 38.56 11.0958 38.5877 10.9342C38.6153 10.7727 38.5875 10.6065 38.5087 10.4627L37.1282 7.28744L39.6204 4.83152C39.6962 4.7613 39.7562 4.67572 39.7963 4.58049C39.8364 4.48527 39.8557 4.38259 39.8529 4.2793C39.842 4.09673 39.7626 3.925 39.6306 3.7984C39.4986 3.67179 39.3237 3.59962 39.1409 3.59629Z",
                fill: "#009877"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M53.3108 3.59629H50.4044L48.9512 0.413773C48.8775 0.274416 48.7636 0.160477 48.6242 0.0868013C48.5351 0.0402007 48.4376 0.0116905 48.3374 0.00291116C48.2371 -0.00586815 48.1362 0.00525686 48.0403 0.035646C47.9444 0.0660351 47.8555 0.115088 47.7786 0.179983C47.7017 0.244877 47.6385 0.324331 47.5924 0.413773L46.1392 3.59629H43.2328C43.1278 3.59342 43.0233 3.61338 42.9268 3.65477C42.8302 3.69617 42.7437 3.75802 42.6733 3.83607C42.556 3.97989 42.4982 4.16314 42.5117 4.34824C42.5252 4.53335 42.609 4.70626 42.746 4.83152L45.2382 7.28744L43.8577 10.4627C43.7726 10.608 43.7406 10.7783 43.7672 10.9445C43.7937 11.1108 43.8772 11.2627 44.0033 11.3742C44.1294 11.4857 44.2904 11.55 44.4586 11.556C44.6269 11.5621 44.792 11.5095 44.9258 11.4073L48.2754 9.52537L51.6251 11.4073C51.7594 11.5012 51.9216 11.5469 52.0852 11.537C52.2489 11.5271 52.4044 11.4622 52.5264 11.3528C52.6485 11.2433 52.73 11.0958 52.7576 10.9342C52.7852 10.7727 52.7574 10.6065 52.6786 10.4627L51.2981 7.28744L53.7904 4.83152C53.8661 4.7613 53.9261 4.67572 53.9662 4.58049C54.0063 4.48527 54.0256 4.38259 54.0229 4.2793C54.0119 4.09673 53.9325 3.925 53.8005 3.7984C53.6685 3.67179 53.4937 3.59962 53.3108 3.59629Z",
                fill: "#009877"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M67.4827 3.59629H64.5763L63.1231 0.413773C63.0494 0.274416 62.9354 0.160477 62.7961 0.0868013C62.7069 0.0402007 62.6094 0.0116905 62.5092 0.00291116C62.409 -0.00586815 62.3081 0.00525686 62.2122 0.035646C62.1163 0.0660351 62.0273 0.115088 61.9505 0.179983C61.8736 0.244877 61.8103 0.324331 61.7643 0.413773L60.3111 3.59629H57.4047C57.2996 3.59342 57.1952 3.61338 57.0986 3.65477C57.002 3.69617 56.9156 3.75802 56.8452 3.83607C56.7279 3.97989 56.6701 4.16314 56.6836 4.34824C56.6971 4.53335 56.7809 4.70626 56.9179 4.83152L59.4101 7.28744L58.0296 10.4627C57.9445 10.608 57.9125 10.7783 57.939 10.9445C57.9656 11.1108 58.0491 11.2627 58.1752 11.3742C58.3013 11.4857 58.4623 11.55 58.6305 11.556C58.7988 11.5621 58.9639 11.5095 59.0977 11.4073L62.4473 9.52537L65.7969 11.4073C65.9313 11.5012 66.0935 11.5469 66.2571 11.537C66.4208 11.5271 66.5762 11.4622 66.6983 11.3528C66.8204 11.2433 66.9018 11.0958 66.9295 10.9342C66.9571 10.7727 66.9293 10.6065 66.8505 10.4627L65.47 7.28744L67.9622 4.83152C68.038 4.7613 68.098 4.67572 68.1381 4.58049C68.1781 4.48527 68.1975 4.38259 68.1947 4.2793C68.1838 4.09673 68.1044 3.925 67.9724 3.7984C67.8404 3.67179 67.6655 3.59962 67.4827 3.59629Z",
                fill: "#009877"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FiveStars);


/***/ }),

/***/ 3245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ FlexWrapItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  /* gap: calc( ",
        " * var( --grid-gutter ) ) calc( ",
        " * var( --stack-basis ) ); */\n  margin: \n    calc( ",
        " * var( --stack-basis ) * -1 ) \n    calc( ",
        " * var( --grid-gutter ) * -1 );\n\n  > * {\n    flex-grow: 1;\n    margin: \n      calc( ",
        " * var( --stack-basis ) ) \n      calc( ",
        " * var( --grid-gutter ) );\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-basis: ",
        ";\n  flex-grow: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var FlexWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-60ee3ef8-0"
})(_templateObject(), function(p) {
    return p.$gap;
}, function(p) {
    return p.$gap;
}, function(p) {
    return p.$gap / 2;
}, function(p) {
    return p.$gap / 2;
}, function(p) {
    return p.$gap / 2;
}, function(p) {
    return p.$gap / 2;
});
FlexWrap.defaultProps = {
    $gap: 1
};
var FlexWrapItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-60ee3ef8-1"
})(_templateObject1(), function(p) {
    return p.$flexBasis;
}, function(p) {
    return p.$flexGrow;
});
/* harmony default export */ __webpack_exports__["Z"] = (FlexWrap);


/***/ }),

/***/ 7321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _partnerSlug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/AppChrome.tsx
var AppChrome = __webpack_require__(1904);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(6797);
// EXTERNAL MODULE: ./components/layout/Background.tsx
var Background = __webpack_require__(7940);
// EXTERNAL MODULE: ./components/layout/FlexWrap.tsx
var FlexWrap = __webpack_require__(3245);
// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(4970);
// EXTERNAL MODULE: ./components/Image.tsx
var Image = __webpack_require__(7753);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(570);
// EXTERNAL MODULE: ./components/icons/FiveStars.tsx
var FiveStars = __webpack_require__(534);
// EXTERNAL MODULE: ./components/PartnerLogo.tsx
var PartnerLogo = __webpack_require__(8605);
;// CONCATENATED MODULE: ./components/HeroPhoto.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  @media ( max-width: ",
        "px ) {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n  flex: 0 0 calc( 50% - var( --grid-gutter ) );\n  margin-left: auto;\n  aspect-ratio: 1.3/1;\n  border-bottom-left-radius: 100rem;\n  border-top-left-radius: 100rem;\n\n  @media ( min-width: ",
        "px ) and ( max-width: 950px ) {\n    flex-basis: 40%;\n    height: 65vw;\n    border-top-left-radius: 0;\n  }\n\n  @media ( max-width: ",
        "px ) {\n    height: 65vw;\n    margin-left: 0;\n    border-radius: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  overflow: hidden;\n  max-width: 600px;\n  padding-left: calc( 3 * var( --grid-gutter ) );\n  padding-right: calc( 2 * var( --grid-gutter ) );\n\n  @media ( max-width: ",
        "px ) {\n    padding-left: var( --container-margin-width );\n    padding-right: var( --container-margin-width );\n  }\n\n  @media ( min-width: 1650px ) {\n    padding-left: 0;\n  }\n\n  h1 {\n    ",
        ";\n    line-height: 1.1;\n  }\n\n  p {\n    ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  p {\n    margin: 0;\n    font-size: ",
        ";\n\n    span {\n      margin-left: 0.5em;\n      font-weight: 600;\n      white-space: nowrap;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










function HeroPhoto(param) {
    var title = param.title, subtitle = param.subtitle, image = param.image, buttonLabel = param.buttonLabel, buttonLink = param.buttonLink, partnerLabel = param.partnerLabel, partnerLogos = param.partnerLogos, testimonial = param.testimonial;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Expander */.x, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Background/* default */.Z, {
            $color: "ivory",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                $containerType: "full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroGrid, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroContent, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                                $flex: true,
                                $top: 5,
                                $bottom: 5,
                                $between: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: subtitle
                                    }),
                                    buttonLink && buttonLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* StackItem */.vO, {
                                        $top: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                            color: "red",
                                            href: buttonLink,
                                            children: buttonLabel
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* StackItem */.vO, {
                                        $top: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWrap/* default */.Z, {
                                            $gap: 2,
                                            children: [
                                                (partnerLogos === null || partnerLogos === void 0 ? void 0 : partnerLogos.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerLogo/* default */.Z, {
                                                    label: partnerLabel,
                                                    logos: partnerLogos
                                                }),
                                                testimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexWrap/* FlexWrapItem */.k, {
                                                    $flexBasis: "350px",
                                                    $flexGrow: 1,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTestimonial, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FiveStars/* default */.Z, {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                children: [
                                                                    "“",
                                                                    testimonial.description,
                                                                    "”",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        children: [
                                                                            "~ ",
                                                                            testimonial.title
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPhoto, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                                src: image.url,
                                alt: image.alt,
                                dateModified: image.dateModified,
                                layout: "fill",
                                objectFit: "cover"
                            })
                        })
                    ]
                })
            })
        })
    });
}
var breakpoint = 600;
var StyledHeroGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ce80197-0"
})(_templateObject(), breakpoint);
var StyledPhoto = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ce80197-1"
})(_templateObject1(), breakpoint + 1, breakpoint);
var StyledHeroContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ce80197-2"
})(_templateObject2(), breakpoint, function(p) {
    return p.theme.typo.heroTitle;
}, function(p) {
    return p.theme.typo.heroSubTitle;
});
var StyledTestimonial = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ce80197-3"
})(_templateObject3(), function(p) {
    return p.theme.typo.sizes.dropped;
});
/* harmony default export */ var components_HeroPhoto = (HeroPhoto);

// EXTERNAL MODULE: ./components/pageSegments/PageSegments.tsx + 88 modules
var PageSegments = __webpack_require__(1135);
;// CONCATENATED MODULE: ./pages/_partners/[partnerSlug]/index.tsx




function PartnerHome(param) {
    var homepage = param.entry;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppChrome/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HeroPhoto, {
                    title: homepage.mainTitle,
                    subtitle: homepage.subtitle,
                    image: homepage.mainImage[0],
                    buttonLabel: homepage.buttonLabel,
                    buttonLink: homepage.buttonLink,
                    partnerLabel: homepage.partnerLabel,
                    partnerLogos: homepage.logos,
                    testimonial: homepage.testimonial[0] || null
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegments/* default */.Z, {
                    pageSegments: homepage.pageSegments
                })
            ]
        })
    });
}
var __N_SSP = true;
/* harmony default export */ var _partnerSlug_ = (PartnerHome);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,756,274,783,135,888,179], function() { return __webpack_exec__(7746); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);